import React from 'react';
import { useNavigate } from 'react-router-dom';
import {
  Box,
  Typography,
  Link,
  Paper
} from '@mui/material';
import Disclaimer from './Disclaimer';

const Footer = () => {
  const navigate = useNavigate();

  const handleLinkClick = (path) => (event) => {
    event.preventDefault();
    navigate(path);
  };

  return (
    <Paper 
      component="footer"
      sx={{ 
        mt: 'auto',
        backgroundColor: 'background.paper',
        borderTop: '1px solid',
        borderColor: 'divider',
        py: 3,
        px: 2
      }} 
      elevation={0}
    >
      <Box sx={{ maxWidth: 800, mx: 'auto' }}>
        {/* Footer Links */}
        <Box 
          sx={{ 
            display: 'flex', 
            flexWrap: 'wrap',
            justifyContent: 'center',
            gap: { xs: 2, sm: 4 },
            mb: 3
          }}
        >
          <Link
            href="#"
            onClick={handleLinkClick('/about')}
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              fontSize: '0.875rem',
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'underline'
              }
            }}
          >
            About Us
          </Link>
          <Link
            href="#"
            onClick={handleLinkClick('/privacy')}
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              fontSize: '0.875rem',
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'underline'
              }
            }}
          >
            Privacy Policy
          </Link>
          <Link
            href="#"
            onClick={handleLinkClick('/terms')}
            sx={{
              color: 'text.secondary',
              textDecoration: 'none',
              fontSize: '0.875rem',
              '&:hover': {
                color: 'primary.main',
                textDecoration: 'underline'
              }
            }}
          >
            Terms & Conditions
          </Link>
        </Box>

        {/* Disclaimer */}
        <Disclaimer />
      </Box>
    </Paper>
  );
};

export default Footer;
